import { useAppSelector } from '../reducers';
import { purchaseRequestTermsFromProductConfigurationsSelector } from '../selectors/OfferSelectors';
import { productConfigurationsToRequestedProductsSelector } from '../selectors/ProductConfigsSelectors';
export const usePurchaseOrderGeneration = ({
  productConfigurations,
  queryParamTerm
}) => {
  const requestedProducts = useAppSelector(state => productConfigurationsToRequestedProductsSelector(state, {
    productConfigurations
  }));
  const terms = useAppSelector(state => purchaseRequestTermsFromProductConfigurationsSelector(state, {
    productConfigurations,
    queryParamTerm
  }));
  return {
    requestedProducts,
    terms
  };
};